import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import { LOCKED_KEY } from '../constants';
import LoaderService from '../../../Services/LoaderService';
import TooltipComponent from '../../TooltipComponent';
import SimpleSelectFilter from '../Filter/SimpleSelectFilter';
import useFilter from '../hooks/useFilter';
import { rideBookFilterAtom } from '../TripsOverviewState';
import { getDataForFilter } from '../TripsOverviewService';
import useAnalytics from '../../../hooks/useAnalytics';

interface IThLockedProps {
  id: string;
}

function ThLockded(props: IThLockedProps): JSX.Element {
  const [tableActionsFilters, setTableActionsFilters] = useRecoilState(
    rideBookFilterAtom(props.id)
  );
  const { formatMessage: f } = useIntl();
  const { updateFilterItemsState } = useFilter();
  const { trackEvent } = useAnalytics();

  const getFilterData = async () => {
    LoaderService.showLoader(true);
    const dataForFilter = await getDataForFilter(LOCKED_KEY);

    if (dataForFilter) {
      updateFilterItemsState([
        { id: props.id, isOpen: true, isActionChipsOpen: false, data: dataForFilter, values: null },
      ]);

      LoaderService.showLoader(false);
    } else {
      LoaderService.showLoader(false);
    }
  };

  const handleOnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    const { id } = event.currentTarget;
    trackEvent(['ride book', 'click', `Ride book open filter ${id}`]);

    setTableActionsFilters(
      (tableActionFilter) =>
        tableActionFilter && {
          ...tableActionFilter,
          id: props.id,
          isOpen: true,
          isActionChipsOpen: false,
        }
    );

    if (id) {
      if (!tableActionsFilters) {
        getFilterData();
      }
    }
  };

  const renderSimpleSelect = (): JSX.Element | null => {
    if (
      tableActionsFilters &&
      tableActionsFilters.isOpen &&
      !tableActionsFilters.isActionChipsOpen &&
      tableActionsFilters.data
    ) {
      return (
        <SimpleSelectFilter
          id={props.id}
          filterValues={tableActionsFilters.data}
          title={f({ id: 'table_list.columns.locked' })}
        />
      );
    }

    return null;
  };

  return (
    <div
      className={`w-sm th-sticky text-center d-flex align-items-center justify-content-center `}
      style={{
        minWidth: '40px',
        maxWidth: '40px',
        width: '40px',
        whiteSpace: 'nowrap',
      }}
    >
      <TooltipComponent
        id={`ridebook-${props.id}`}
        overlay={
          <div style={{ color: '#fff', whiteSpace: 'pre-wrap', fontWeight: 'normal' }}>
            {`${f({
              id: 'tables.tripsOverview.header.tooltip.locked',
            })}`}
          </div>
        }
        width="300px"
        style={{ top: '35px' }}
        positionLeft
      >
        <i
          className={`cmd-icons cmd-icon-lock-table fs-4 ${
            tableActionsFilters && tableActionsFilters.values ? 'text-active' : ''
          }`}
          onClick={handleOnClick}
          id={props.id}
          data-cy={`filter-button-${props.id}`}
        />
      </TooltipComponent>
      <div />
      {renderSimpleSelect()}
    </div>
  );
}

export default ThLockded;
